import { ObjectsType } from '../objects/get.module';
import { getEventModule } from './get.module';

const module = getEventModule(ObjectsType.Faces);
export default module;
